// Performance optimization utilities

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const throttle = (func, limit) => {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

// Preload critical resources
export const preloadResources = () => {
  // Preload critical images
  const criticalImages = [
    'https://i.imghippo.com/files/yeSd8206FjQ.png',
    'https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=800&h=600&fit=crop&auto=format'
  ];

  criticalImages.forEach(src => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });

  // Preconnect to external domains
  const domains = [
    'https://images.unsplash.com',
    'https://i.imghippo.com',
    'https://nominatim.openstreetmap.org'
  ];

  domains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// Web Vitals monitoring
export const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Optimized image URL generator
export const getOptimizedImageUrl = (url, width = 800, height = 600, quality = 75) => {
  if (!url) return '';
  
  if (url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    const params = new URLSearchParams({
      w: width.toString(),
      h: height.toString(),
      fit: 'crop',
      auto: 'format',
      q: quality.toString(),
      fm: 'webp'
    });
    return `${baseUrl}?${params.toString()}`;
  }
  
  return url;
};